import { render } from "./BuySell.vue?vue&type=template&id=30c2049c"
import script from "./BuySell.vue?vue&type=script&lang=js"
export * from "./BuySell.vue?vue&type=script&lang=js"

import "./BuySell.vue?vue&type=style&index=0&id=30c2049c&lang=css"
script.render = render

export default script